// extracted by mini-css-extract-plugin
export default {"input":"radio-input_input__FLiRw","label":"radio-input_label__V4NFR"};